import * as React from 'react';
import {enhance} from './enhancer';
import {Link} from 'react-router-dom';
import Table from '@/migration/table/Table';
import {Field} from 'redux-form';
import {Search} from '@/migration/search';
import {Icon} from 'semantic-ui-react';
import {NewsTableColumns} from './../../../components/News';
import {config} from './../../../config';
import {lifecycle} from './lifecycle';
import {setState} from './state';
import {handler} from './handler';

import './index.scss';

function UsersMain(props: any) {
  const {paths} = config;
  const state = setState();
  lifecycle.componentDidMount(state, props);

  return (
    <div className="a__news-main">
      <div className="b__title c__after-title">
        <h1 style={{fontFamily: 'UD Shin Go Medium'}}> 通知 </h1>
      </div>
      <div className="b__sub">
        <div className="b__search">
          <Field
            name="searchWord"
            component={Search}
            placeholder="検索ワードを入力"
            addSearchWord={handler.addSearchWord(state, props)}
            searchWords={props.news.searchWords}
            removeSearchWord={handler.removeSearchWord(state, props)}
            outline
          />
        </div>
        <div className="b__create">
          <Link to={paths.news.create}>
            <span>
              <Icon name="add" />
              通知を追加する
            </span>
          </Link>
        </div>
      </div>
      <div className="b__news">
        <Table
          active={props.news.pages.active}
          columns={NewsTableColumns(props)}
          current={props.news.current}
          totalCount={props.news.totalCount}
          loading={state.loading}
          updateCurrent={handler.updateCurrent(state, props)}
          disabled={state.disabled}
          sortState={props.news.sortState}
          updateSortState={handler.updateSortState(state, props)}
        />
      </div>
    </div>
  );
}

export default enhance((props: any) => <UsersMain {...props} />);
